
import { Component, Vue, Watch, Mixins } from 'vue-property-decorator';
import TopNavBar from '@/components/app/TopNavBar.vue';
import { DeviceInfo } from '@/types/device-info';
import { State } from 'vuex-class';
import api from '@/modules/api';
import dayjs from 'dayjs';
import { UserInfo } from '@/types/user-info';
import DeviceListRow from '@/components/devices/DeviceListRow.vue';
import { mutations } from '@/store/types';
import { getErrorMessage } from '@/utils/common';

@Component({
    components: {
        TopNavBar,
        DeviceListRow,
    },
})
export default class CreateGroupDevices extends Vue {

    searchDevices: DeviceInfo[] = [];
    selectedDevices: string[] = [];
    devices!: DeviceInfo[];
    protected debounceSearch: any | null = null;

    groupName = "";
    searchQuery = "";
    groupDevicesModel = false;

    @State('loading')
    readonly loading!: boolean;

    @State('user')
    user!: UserInfo;

    @State('device')
    current!: DeviceInfo;

    headers = [
        { text: 'Name', value: 'name' },
        { text: 'Devices', value: 'totalDevices' },
        { text: 'Created At', value: 'createdAt' },
        { text: 'Action', value: 'action' },
    ];

    slots = [
        {
            name: 'item.totalDevices',
            template: ({ item }: { item: any }) => item?.devices?.length,
        },
        {
            name: 'item.createdAt',
            template: ({ item }: { item: any }) => dayjs(item?.createdAt).format('DD/MM/YYYY'),
        },
    ];

    @Watch('devices', { immediate: true })
    onDevicesChange(current: DeviceInfo[] | []) {
        this.searchDevices = current;
    }

    async fetch(search = '') {
        this.devices = await api.loadDevices(
            this.user._id as string,
            { page: 0, perPage: 999 },
            '',
            search,
        );
        this.searchDevices = this.devices;
    }

    mounted() {
        this.fetch();
    }

    @Watch('searchQuery')
    searchChanged() {
        if (this.debounceSearch) {
            clearTimeout(this.debounceSearch);
            this.debounceSearch = null;
        }

        this.debounceSearch = setTimeout(() => {
            this.fetch(this.searchQuery);
        }, 500);
    }

    async handleSubmit(e: Event) {
        try {
            e.preventDefault();
            this.$store.commit(mutations.LOADING, { loading: true });
            const response = await api.createDeviceGroup(this.groupName, this.selectedDevices);
            this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: this.groupName });
            this.$router.push({
                name: 'group-device',
                params: { groupId: response.groupId }
            });
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: true });
        }

    }

    handleCancel() {
        this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: 'all' });
        this.$router.push({ name: 'device-overview', params: { deviceUUID: this.current.deviceUUID as string } });
    }
}
